export default __webpack_public_path__ + "static/media/perfecto_flush_2.e18ff8f2.jpeg";